import type { LoadingAnimationProps } from './LoadingAnimation.types';
import { Shimmer } from './Shimmer';
import { Spinner } from './Spinner';

export const LoadingAnimation = (props: LoadingAnimationProps) => {
  if (props.type === 'spinner') {
    const { type, ...spinnerProps } = props;

    return <Spinner {...spinnerProps} />;
  }

  const { type, ...shimmerProps } = props;

  return <Shimmer {...shimmerProps} />;
};
